import { render } from "./WClientesNuevosPorMes.vue?vue&type=template&id=032b8a04&scoped=true"
import script from "./WClientesNuevosPorMes.vue?vue&type=script&lang=js"
export * from "./WClientesNuevosPorMes.vue?vue&type=script&lang=js"

import "./WClientesNuevosPorMes.vue?vue&type=style&index=0&id=032b8a04&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032b8a04"]])

export default __exports__